import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=3ef363d6&scoped=true&lang=pug&"
import script from "./Shop.vue?vue&type=script&lang=js&"
export * from "./Shop.vue?vue&type=script&lang=js&"
import style0 from "./Shop.vue?vue&type=style&index=0&id=3ef363d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef363d6",
  null
  
)

export default component.exports